import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	makeStyles,
	MenuItem,
	TextField,
	Typography,
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AlertNotistack from "../../components/molecules/AlertNotistack";

const useStyles = makeStyles((theme) => ({
	formControl: {
		minWidth: "100%",
	},
	textField: {
		width: "100%",
		"& + & ": {
			marginTop: theme.spacing(1.5),
		},
	},
}));

export default function FormOnEditUsers(props) {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();
	const { open, handleClose, editData, option, fetchAPI } = props;
	const { register, handleSubmit, errors, clearErrors, formState } = useForm();
	const [onError, setOnError] = useState(true);
	const [editDatas, setEditDatas] = useState({
		id: "",
		nama_user: "",
		username: "",
		email: "",
		role: "",
		telp: "",
	});

	const { id, nama_user, username, email, role, telp } = editDatas;

	const onSubmit = async (item) => {
		if (validateEmail(item.email)) {
			await fetchAPI("edit", editDatas);
			clearErrors();
		} else {
			return enqueueSnackbar("Email Tidak Valid", AlertNotistack("error"));
		}
	};

	useEffect(() => {
		if (
			editData?.nama_user === editDatas?.nama_user &&
			editData?.username === editDatas?.username &&
			editData?.email === editDatas?.email &&
			editData?.role === editDatas?.role &&
			editData?.telp === editDatas?.telp
		) {
			return setOnError(true);
		}
		return setOnError(false);
	}, [editData, editDatas, onError]);

	useEffect(() => {
		if (editData) {
			setEditDatas({
				id: editData.id,
				nama_user: editData.nama_user,
				username: editData.username,
				email: editData.email,
				role: editData.role,
				telp: editData.telp,
			});
		}
	}, [editData]);

	const handleFieldChange = (e) =>
		setEditDatas({ ...editDatas, [e.target.name]: e.target.value });

	const validateEmail = (email) => {
		const re =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<form onSubmit={handleSubmit(onSubmit)}>
					<DialogTitle id="form-dialog-title">Edit On Users</DialogTitle>
					<DialogContent>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={12}>
								<TextField
									disabled
									id="id"
									name="id"
									value={id}
									label="ID"
									type="number"
									fullWidth
									variant="outlined"
									inputRef={register}
								/>
							</Grid>
							<Grid item xs={12} sm={12}>
								<TextField
									disabled
									id="username"
									name="username"
									value={username}
									label="Username"
									type="string"
									fullWidth
									variant="outlined"
									inputRef={register}
								/>
							</Grid>
							<Grid item xs={12} sm={12}>
								<TextField
									id="nama_user"
									name="nama_user"
									value={nama_user}
									onChange={handleFieldChange}
									label="Nama User "
									fullWidth
									placeholder="Type your Nama user"
									type="string"
									variant="outlined"
									error={errors.nama_user}
									required
									helperText={errors.nama_user && errors.nama_user.message}
								/>
							</Grid>
							<Grid item xs={12} sm={12}>
								<TextField
									id="email"
									name="email"
									value={email}
									onChange={handleFieldChange}
									label="EMAIl"
									placeholder="Type your EMAIL"
									type="email"
									variant="outlined"
									error={errors.email}
									inputRef={register()}
									required
									helperText={errors.email && errors.email.message}
									fullWidth
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<TextField
									select
									className={classes.textField}
									label="Role"
									id="role"
									name="role"
									defaultValue={role}
									fullWidth
									onChange={handleFieldChange}
									variant="outlined"
									required
								>
									<MenuItem value="none" disabled selected>
										--Pilih Role--
									</MenuItem>
									{option &&
										option.map((item, i) => (
											<MenuItem key={i} value={item.id}>
												{item.nama}
											</MenuItem>
										))}
								</TextField>
								{errors.role && (
									<Typography variant="caption" color="error">
										{errors.role.message}
									</Typography>
								)}
							</Grid>

							<Grid item xs={12} sm={12}>
								<TextField
									id="telp"
									name="telp"
									label="Telepon"
									error={errors.telp}
									fullWidth
									onChange={handleFieldChange}
									variant="outlined"
									value={telp}
									placeholder="Type your Telepon"
									type="number"
									inputRef={register({
										minLength: {
											value: 10,
											message: "Minimal length phone number 10",
										},
										maxLength: {
											value: 14,
											message: "Maximal length phone number 14",
										},
									})}
									required
									helperText={errors.telp && errors.telp.message}
								/>
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
						<Button
							type="submit"
							color="primary"
							disabled={formState.isSubmitting}
						>
							Save
						</Button>
						<Button onClick={handleClose} color="secondary">
							Cancel
						</Button>
					</DialogActions>
				</form>
			</Dialog>
		</div>
	);
}
